import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-skeleton-block',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="skeleton-stack" [ngStyle]="{ gap }">
      <div
        *ngFor="let _ of items"
        class="skeleton"
        [ngStyle]="{
          height,
          width,
          borderRadius: rounded
        }"
      ></div>
    </div>
  `,
  styles: [
    `
      .skeleton-stack {
        display: flex;
        flex-direction: column;
      }
    `,
  ],
})
export class SkeletonBlockComponent {
  /** CSS length, e.g. '12px', '1rem', '48px' */
  @Input() height: string = '12px';
  /** CSS length/percentage, e.g. '100%', '240px' */
  @Input() width: string = '100%';
  /** CSS border-radius, e.g. '8px' */
  @Input() rounded: string = 'var(--skeleton-radius, 0.5rem)';
  /** Number of stacked blocks (useful for “lines”) */
  @Input() lines: number = 1;
  /** CSS gap between lines */
  @Input() gap: string = '8px';

  get items(): number[] {
    const n = Number.isFinite(this.lines) ? Math.max(1, Math.floor(this.lines)) : 1;
    return Array.from({ length: n }, (_v, i) => i);
  }
}

